import React from 'react'
import popup from '~/views/Popup/popup'

const cancelledSubscription = () => {
    return (
      <section>
        <div className="title site-color">Subscription</div>
        <div className="detail">
          <div className="main">
            <div className="next-step">
              You have cancelled your subscription.
            </div>
          </div>
          <div className="buttons">
            <a href="/viewplans" className="button">Subscribe Now</a>
            <div className="button" onClick={ _ => popup.billingHistory() }>Billing History</div>
          </div>
        </div>
        <div className="clearfix"></div>
      </section>)
}

export default cancelledSubscription;
